export const ItemTypes = {
  BACKLOG: "Backlog",
  READY: "Ready",
  DOING: "Doing",
  DONE: "Done",
  REVIEW: "Review",
  BLOCKED: "Blocked",
};
